import authRequest from '../../utils/authRequest'
import DocumentPresenter from '../../presenters/DocumentPresenter'

const updateDocument = async (uuid, attributes) => {
  try {
    const response = await authRequest(`/documents/${uuid}`, {
      method: 'PATCH',
      data: { document: attributes },
    })

    if (response.status === 200) {
      return new DocumentPresenter(response.data)
    } else {
      throw new Error('Failed to update document')
    }
  } catch (error) {
    console.error('Error updating document:', error)
    throw error
  }
}

export default updateDocument